<template>
    <div>
        <a-button @click="showModal" class="btn-outline-primary">
            تغییر موجودی
        </a-button>

        <a-modal width="1000px" v-model="visible" title="تغییر موجودی کاربر" on-ok="handleOk">
            <template slot="footer">
                <a-button key="back" @click="handleCancel">
                    بستن
                </a-button>

            </template>
            <form @submit.prevent="addData($event)">
                <input type="hidden" name="user_id" :value="userId">
                <div class="row">

                    <div class="col-md-4">
                        <div class="form-group text-right">
                            <label for="">(ریال) مقدار پول</label>
                            <input v-model="info.amount" name="amount" type="number" class="form-control">
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group text-right">
                            <label class="sr-only" for="inline-form-input-name">
                                نوع حساب</label>
                            <a-select v-model="info.account" mode="single" style="width:100%"
                                placeholder="انتخاب  نوع حساب">
                                <a-select-option key="wallet" value="wallet">
                                    حساب کیف پول
                                </a-select-option>

                                <a-select-option key="investment" value="investment">
                                    حساب سرمایه اولیه
                                </a-select-option>

                                <a-select-option key="barter" value="barter">
                                    حساب تهاتری
                                </a-select-option>
                            </a-select>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group text-right">
                            <label class="sr-only" for="inline-form-input-name">
                                نوع تراکنش</label>
                            <a-select v-model="info.type" mode="single" style="width:100%"
                                placeholder="انتخاب  نوع تراکنش ">
                                <a-select-option key="in" value="in">
                                    افزایش موجودی
                                </a-select-option>
                                <a-select-option key="out" value="out">
                                    کاهش موجودی
                                </a-select-option>
                            </a-select>
                        </div>
                    </div>

                    <div class="col-md-12">
                        <div class="form-group text-right">
                            <label class="sr-only" for="inline-form-input-name">
                                توضیحات تراکنش</label>
                            <textarea v-model="info.description" class="form-control" name="description" id="" cols="5" rows="5"></textarea>
                        </div>
                    </div>
                    <div class="mt-1">
                        <button :disabled="loading" type="submit" class="btn btn-fill btn-outline-success ">
                            ذخیره
                        </button>
                    </div>
                </div>
            </form>
        </a-modal>
    </div>
</template>
<script>
    export default {
        props: {
            userId: String,
        },
        data() {
            return {
                loading: false,
                visible: false,
                info: {},

            };
        },
        methods: {
            addData(event) {
                let _this = this;
                let data = new FormData(event.target);
                data.append("account", this.info.account);
                data.append("type", this.info.type);
                this.loading = true;
                axios
                    .post("/transactions/add", data)
                    .then(function(response) {
                        _this.info = {};
                        _this.loading = false;
                        _this.$toast.success("  تراکنش با موفقیت افزوده شد");
                    })
                    .catch(function(err) {
                        _this.info = {};
                        _this.loading = false;
                        _this.$root.handleAxiosError(err);
                    });
            },
            showModal() {
                this.visible = true;
            },
            handleOk(e) {
                this.loading = true;
                setTimeout(() => {
                    this.visible = false;
                    this.loading = false;
                }, 3000);
            },
            handleCancel(e) {
                this.visible = false;
                this.$emit('getData')
            },
        }
    };
</script>
